<template>
	<div class="recom">
		<h3 class="h3-title">{{title}}</h3>
		<p class="recom-description" :class="{'active': isOpen}" v-html="single">
		</p>
		<button @click="open" class="recom-more">{{!isOpen ? 'Читать дальше...' : 'Скрыть'}}</button>
	</div>
</template>

<style lang="css">
	.recom-description {
		height: 54px;
		min-height: 54px;
		overflow: hidden;
		font-weight: normal;
		font-size: 14px;
		line-height: 18px;
		color: #404044;
	}
	.recom-description.active {
		height: auto;
	}
	.recom-more {
		cursor: pointer;
		padding: 0;
		background: transparent;
		border: none;
		outline: none !important;
		color: #428EFF;
		border-bottom: 1px solid #428EFF;
	}
</style>
<script>
	export default {
		props: {
			title: {
				type: String,
				default: '',
				required: true,
			},
			single: {
				type: String,
				default: '',
				required: true,
			},
		},
		data() {
			return {
				isOpen: false,
			}
		},
		methods: {
			open() {
				this.isOpen = !this.isOpen;
			}
		}
	}
</script>
